import React, { useState, useCallback, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import LoadingComponent from '../LoadingComponent';
import { ImCross } from "react-icons/im"
import Button from '../Button';
import SmallButton from '../SmallButton';
import TextboxComp from '../TextboxComp';

interface MessageModalI {
  item: any;
  itemid: any;
  state: boolean;
  handleClose: ()=> void;
  update: (id: any, q: any, a: any)=>void;
  deleteitem: (idx: any)=>void;
}

const EditQAModal: React.FC<MessageModalI> = ({item, itemid, state,handleClose, update, deleteitem }) => {

	const [ progress, setprogress ] = useState(false)
	const [ toggle, settoggle ] = useState(false)

	const changequestion = (e: any) =>{
		item.question = e.target.value
		settoggle(!toggle)
	}

	const changeanswer = (e: any) =>{
		item.answer = e.target.value
		settoggle(!toggle)
	}

	useEffect(()=>{
		
	}, [])
	useEffect(()=>{
		
	}, [toggle])

	return (
		<>
		{state && (
			<StyledBackdrop>&nbsp;
			<StyledModal>
				<HeaderContainer>
				<Header>Edit Item</Header>
				<CloseIcon onClick={handleClose}><ImCross fontSize={"20px"} color={"#0F2557"}/></CloseIcon>
				</HeaderContainer>
				<Body>
				{item?<>
				<TextboxComp key={`tb_qkey_${item._id}`} id={`tb_qid_${item._id}`} value={item.question} onChange={(e: any)=>{changequestion(e)}} rows={5} cols={50} height={100} placeholder='question'/>
				<TextboxComp key={`tb_key_${item._id}`} id={`tb_id_${item._id}`} value={item.answer} onChange={(e: any)=>{changeanswer(e)}} rows={5} cols={50} height={100} placeholder='answer'/>
				</>:<></>}
				{
					progress?<LoadingComponent /> :
					<><ButtonContainer>
					<Item style={{flex:0.10}}><SmallButton text="update" handleClick={(e)=>{update(itemid, item.question, item.answer)}} /> </Item>
					<Item style={{flex:0.10}}><SmallButton text="delete" handleClick={(e)=>{deleteitem(itemid)}}  backgroundColor={"#FF5578"}/> </Item>
				</ButtonContainer></>
				}
				<Button handleClick={handleClose} text="Close" />
				</Body>
			</StyledModal>
			</StyledBackdrop>
		)}
		</>
	)
}

const Slidein = keyframes`
  0% {
    transform: translate(-50%, 100%);
  }
  100% {
    transform: translate(-50%, -50%);
  }
`;

const StyledBackdrop = styled.div`
  position: relative;
  opacity: 1;
  // top: -50%;
  // right: 150%;
  // bottom: 150%;
  // left: -50%;
  z-index: 999;
  background-color: #000;
  height: 200vh;
  width: 100vw;
`;

const StyledModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  background: #f0f0f0;
  border-radius: 10px;
  width: min(500px, 75%);
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%, -50%);
  animation: ${Slidein} 0.5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
`

const HeaderContainer = styled.div`
  display: flex;
  padding: 20px;
  background-color: #eee;
  border-radius: 10px 10px 0 0;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid gray;
  color: black;
`

const Header = styled.div`
  display: flex;
  font-size: 25px;
  font-weight: 600;
  color: #0F2557;
`

const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  line-height: 2;
  font-size: 14px;
  font-weight: 500;
  color: black;
  margin: 10px;
  padding: 10px;
`
const CloseIcon = styled.div`
  margin: 5px;
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  text-transform: uppercase;
  padding: 7px;
  font-weight: 500;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(100, 100, 100, 0.25);
  background-color: transparent;
  color: #c1c1c1;
  width: auto;
  transition: ease 0.5s;
  &:hover {
      box-shadow: 0 2px 4px 2px rgba(100, 100, 100, 1);
  }
`;  

const ButtonContainer = styled.div`
  display: flex;
`;

const Item = styled.div`
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    color: black;
`;

export default EditQAModal
